import styled, { css } from 'styled-components';
import { LinkStyledProps } from './Link.types';
import { get } from 'lodash';

const Link = styled.a<LinkStyledProps>`
  color: ${(props) =>
    get(props.theme.brand, props.$color) || props.theme.brand.primary.base};

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      color: #999;
    `}

  ${({ $underline }) =>
    $underline &&
    css`
      text-decoration: ${$underline === 'dotted'
        ? 'underline dotted'
        : 'underline'};
      text-underline-offset: 0.5rem;
    `}
`;

export { Link };
